export const DEFAULT_LANG = 'no'

export const REASONS_FOR_CONTACT = [
  {
    label: 'generalQuestion',
    value: 'generalQuestion',
  },
  {
    label: 'cooperationIdea',
    value: 'cooperationIdea',
  },
  {
    label: 'brokenItem',
    value: 'brokenItem',
  },
]

export const REPORTS_TYPES = [
  {
    label: 'products',
    value: 'products',
  },
  // {
  //   label: 'orders',
  //   value: 'orders',
  // },
  {
    label: 'users',
    value: 'users',
  },
]

export const DATE_FORMATS = {
  fullDate: 'dd MMM yyyy HH:mm',
  noYearDate: 'd MMM HH:mm',
  day: 'dd MMM yyyy',
  time: 'HH:mm',
  fullOnlyDate: 'dd MMM yyyy',
  noYearOnlyDate: 'd MMM',
}

export const STORAGE_KEYS = {
  language: 'language',
  shouldRememberCustomer: 'shouldRememberCustomer',
  orderId: 'orderId',
  orderToken: 'orderToken',
  userToken: 'userToken',
  redirectTo: 'redirectTo',
}

export const CUSTOMER_ROLES = {
  admin: 'admin',
  user: 'user',
}

export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&\\\/,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?"!@#%&\\\/,><':;|_~`=+\- ]{8,256}$/

export const I18_COOKIE_NAME = 'i18next-lang'
